export default "__VITE_ASSET__BIwG1o2u__"